import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import TypographyBasic from '../Typography/TypographyBasic';

var Text = function Text(_ref) {
  var id = _ref.id,
      children = _ref.children,
      size = _ref.size,
      className = _ref.className,
      style = _ref.style,
      color = _ref.color,
      strong = _ref.strong,
      semantic = _ref.semantic,
      sign = _ref.sign,
      ellipsis = _ref.ellipsis,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(TypographyBasic, {
    size: size,
    className: className,
    style: style,
    color: color,
    strong: strong,
    semantic: semantic,
    sign: sign,
    ellipsis: ellipsis,
    theme: theme
  }, /*#__PURE__*/React.createElement("span", {
    id: id,
    className: "jmtd-typography-text"
  }, children));
};

Text.propTypes = _objectSpread({
  children: PropTypes.any
}, TypographyBasic.propTypes);
Text.defaultProps = _objectSpread({
  children: ''
}, TypographyBasic.defaultProps);
export default Text;